import * as bi from 'react-bootstrap-icons';
import { RoutingUrls } from 'common/const';
import { Flex, Header, Box, Message, Button } from 'components';
import { Icon, IconMax, PageSidebar } from 'shared/components';
import { Link } from 'react-router';
import { PublicDocumentsService } from 'common/services';
import { CardProfile } from './components';

function PageSettings() {
  return (
    <PageSidebar
      title='Параметры и данные пользователя'
      frameTitle='Данные и свойства'
    >
      <Flex
        direction='column'
        gap={10}
      >
        <CardProfile />
        <PassengersLinkCard />
        <CompanyData />
      </Flex>
    </PageSidebar>
  );
}

function CompanyData() {
  return (
    <Box padding={20}>
      <Flex
        direction='column'
        gap={10}
      >
        <Header>Информация о сайте</Header>

        <Message type='info'>
          <div>
            Платформа <Link to={RoutingUrls.Main}>Zabus.RU</Link> была разработана компанией АО «Читаавтотранс» для
            повышения комфорта наших партнёров-перевозчиков и покупателей.
            <br />
            Больше нет необходимости стоять в очереди и выходить из дома для покупки билета.
          </div>
        </Message>

        <Flex
          direction='column'
          gap={10}
        >
          <Flex direction='column'>
            <Flex gap={5}>
              <Icon color='red'>
                <bi.Briefcase />
              </Icon>
              <b>Наш ОГРН:</b>
              <span>1027501147629</span>
            </Flex>
            <Flex gap={5}>
              <Icon color='red'>
                <bi.Clipboard />
              </Icon>
              <b>Наш ИНН:</b>
              <span>7536033811</span>
            </Flex>
          </Flex>

          <Flex direction='column'>
            <Flex gap={5}>
              <Icon color='red'>
                <bi.Telegram />
              </Icon>
              <b>Telegram:</b>
              <Link
                to='https://t.me/chitaavtotrans75'
                target='_blank'
              >
                @ChitaAvtoTrans75
              </Link>
            </Flex>
            <Flex gap={5}>
              <Icon color='red'>
                <IconMax />
              </Icon>
              <b>МАКС:</b>
              <span>+7 (914) 350‒26‒26</span>
            </Flex>
          </Flex>

          <Flex direction='column'>
            <Flex gap={5}>
              <Icon color='red'>
                <bi.Telephone />
              </Icon>
              <a href='tel:73022502626'>+7 (3022) 50‒26‒26</a>
            </Flex>
            <Flex gap={5}>
              <Icon color='red'>
                <bi.Telephone />
              </Icon>
              <a href='tel:73022352686'>+7 (3022) 35‒26‒86</a>
            </Flex>
            <Flex gap={5}>
              <Icon color='red'>
                <bi.Telephone />
              </Icon>
              <a href='tel:79143502626'>+7 (914) 350‒26‒26</a>
            </Flex>
          </Flex>
        </Flex>

        <Flex
          direction='column'
          gap={0}
        >
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={PublicDocumentsService.getInstance().consentHref()}
          >
            <Flex
              direction='row'
              gap={5}
            >
              <Icon color='red'>
                <bi.JournalCheck />
              </Icon>

              <span>Согласие на обработку персональных данных</span>
            </Flex>
          </a>

          <a
            href={PublicDocumentsService.getInstance().privacyPolicyHref()}
            target='_blank'
            rel='noopener noreferrer'
          >
            <Flex
              direction='row'
              gap={5}
            >
              <Icon color='red'>
                <bi.JournalCheck />
              </Icon>

              <span>Политика обработки персональных данных</span>
            </Flex>
          </a>
        </Flex>
      </Flex>
    </Box>
  );
}

function PassengersLinkCard() {
  return (
    <Box padding={20}>
      <Flex
        gap={20}
        direction='column'
      >
        <Header>Управление пассажирами</Header>

        <Message type='info'>
          При нажатии на кнопку вы перейдете в раздел управления пассажирами. В этом разделе можно просматривать и
          редактировать данные пассажиров и их документы.
        </Message>

        <Button href={RoutingUrls.Passengers}>
          <Flex
            gap={5}
            alignItems='center'
            justifyContent='center'
          >
            <bi.People />
            <span>Перейти к списку пассажиров</span>
          </Flex>
        </Button>
      </Flex>
    </Box>
  );
}

export default PageSettings;
